export const isUsableResourceId = (value: unknown): value is string =>
  typeof value === 'string' &&
  value.trim().length > 0 &&
  value !== 'undefined' &&
  value !== 'null'
